// javascript-obfuscator:disable

/**
 *
 * @param destinationAddress
 * @param {DataView} destinationView
 * @param sourceAddress
 * @param {DataView} sourceView
 * @return new destination address
 */
export function copyBuffer( destinationAddress, destinationView, sourceAddress, sourceView, byteCount ) {
    while( byteCount>0 ) {
        if ( byteCount >= 4 ) {
            destinationView.setUint32(destinationAddress, sourceView.getUint32(sourceAddress,true), true);
            sourceAddress += 4;
            destinationAddress += 4;
            byteCount -= 4;
        } else {
            destinationView.setUint8( destinationAddress++, sourceView.getUint8(sourceAddress++) );
            byteCount--;
        }
    }
    return destinationAddress;
}